import React from "react";
import "../css/Home1.css";

const Home1 = () => {
  return (
    <div className="home1">

      {/* ------------------ HERO (UNCHANGED) ------------------ */}
      <section className="home1-hero">
        <img
          src="https://images.pexels.com/photos/7319715/pexels-photo-7319715.jpeg"
          alt="Hero"
          className="home1-banner"
        />
        <div className="home1-center">
          <h1 className="solaris-text">ACE FIT</h1>
        </div>
      </section>



      {/* ------------------ SECTION 2 — BRAND IDENTITY ------------------ */}
      <section className="brand-identity reveal">
        <div className="brand-left">
          <h1>ACE IS <br /> A MOVEMENT.</h1>
          <p>
            Not just a gym — a sanctuary for those who thrive on intensity,
            discipline, and unstoppable momentum. Where ambition fuels every rep.
          </p>
        </div>

        <div className="brand-right">
          <div
            className="brand-img"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1558611848-73f7eb4001a1?auto=format&fit=crop&w=1200&q=80')",
            }}
          ></div>
          <div
            className="brand-img"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1517838277536-f5f99be501cd?auto=format&fit=crop&w=1200&q=80')",
            }}
          ></div>
        </div>
      </section>



      {/* ------------------ MOTIVATION STRIP ------------------ */}
      <section className="motivation-strip">
        <h1>POWER. FORM. DISCIPLINE.</h1>
      </section>



      {/* ------------------ NEW SECTION — HOW YOU CAN STAY HEALTHY ------------------ */}
      <section className="healthy-section reveal">
        <h1 className="section-title">HOW YOU CAN STAY HEALTHY</h1>

        <div className="healthy-grid">
          {[
            {
              title: "EAT CLEAN",
              img: "https://images.pexels.com/photos/1495534/pexels-photo-1495534.jpeg",
              text: "Fuel your body with nutrient-rich foods that support strength & energy.",
            },
            {
              title: "TRAIN CONSISTENTLY",
              img: "https://images.pexels.com/photos/6844939/pexels-photo-6844939.jpeg",
              text: "Small daily progress beats rare intensity. Build long-term discipline.",
            },
            {
              title: "REST & RECOVER",
              img: "https://images.pexels.com/photos/35342402/pexels-photo-35342402.jpeg",
              text: "Your muscles grow when you sleep — recovery is part of the workout.",
            },
            {
              title: "STAY HYDRATED",
              img: "https://images.pexels.com/photos/3766257/pexels-photo-3766257.jpeg",
              text: "Hydration improves performance, energy, and overall well-being.",
            },
          ].map((item, i) => (
            <div className="healthy-card" key={i}>
              <div
                className="healthy-img"
                style={{ backgroundImage: `url(${item.img})` }}
              ></div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>


      {/* ------------------ SECTION 4 — PRECISION ENGINEERING ------------------ */}
      <section className="precision-section reveal">
        <div className="precision-inner">
          <h1>PRECISION ENGINEERED.</h1>
          <p>
            Every space, every machine, every program — designed with scientific
            intention. ACE optimizes biomechanics, energy output, and elite-level
            performance.
          </p>
        </div>

        <div
          className="precision-image"
          style={{
            backgroundImage:
              "url('https://images.pexels.com/photos/2827400/pexels-photo-2827400.jpeg')",
          }}
        ></div>
      </section>
      

      {/* ------------------ NEW SECTION — WHY CHOOSE US ------------------ */}
      <section className="why-section reveal">
        <h1 className="section-title">WHY CHOOSE US</h1>

        <div className="why-grid">
          {[
            {
              title: "Certified Trainers",
              text: "All trainers are certified experts ensuring safe and effective training.",
            },
            {
              title: "Science-Backed Programs",
              text: "Training routines built on biomechanics, strength research & performance.",
            },
            {
              title: "Premium Equipment",
              text: "Top-tier machines designed for stability, safety, and muscle activation.",
            },
            {
              title: "Supportive Community",
              text: "A powerful environment that pushes you to become your strongest self.",
            },
          ].map((w, i) => (
            <div className="why-card" key={i}>
              <h3>{w.title}</h3>
              <p>{w.text}</p>
            </div>
          ))}
        </div>
      </section>



      {/* ------------------ FINAL CTA ------------------ */}
      <section className="cta-last reveal">
        <h1>JOIN THE MOVEMENT.</h1>
        <button className="primary-cta">Begin Your Journey</button>
      </section>
    </div>
  );
};

export default Home1;
